import { __assign, __rest } from "tslib";
import React from 'react';
import VeltRecorderPlayerExpandedControlsTogglePauseWireframe from './VeltRecorderPlayerExpandedControlsTogglePauseWireframe/VeltRecorderPlayerExpandedControlsTogglePauseWireframe';
import VeltRecorderPlayerExpandedControlsTogglePlayWireframe from './VeltRecorderPlayerExpandedControlsTogglePlayWireframe/VeltRecorderPlayerExpandedControlsTogglePlayWireframe';
import { transformWireframeProps } from '../../../../utils/propUtils';
var VeltRecorderPlayerExpandedControlsToggleButtonWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recorder-player-expanded-controls-toggle-button-wireframe", __assign({}, transformedProps), children));
};
VeltRecorderPlayerExpandedControlsToggleButtonWireframe.Play = VeltRecorderPlayerExpandedControlsTogglePlayWireframe;
VeltRecorderPlayerExpandedControlsToggleButtonWireframe.Pause = VeltRecorderPlayerExpandedControlsTogglePauseWireframe;
export default VeltRecorderPlayerExpandedControlsToggleButtonWireframe;
